module.exports = __webpack_public_path__ + "img/partseven_user4.ae5e588a.png";